<h2 class="step-title">{{ title }}</h2>
<h3 class="slider-value">{{ sliderDisplay }}</h3>

<div class="slider-container">
  <input class="slider is-fullwidth is-circle is-large" type="range" (input)="slide($event); countVisitorAction();" [(value)]="sliderValue"
    min="0" [max]="sliderValues.length - 1" [sliderValue]="sliderValue" sliderProgress>
  <app-slider-label left="$60K" right="$1.2M"></app-slider-label>

  <div class="field">
    <div class="control">
      @if (inputModeTest) {
        <input
          inputmode="numeric"
          class="input is-large"
          value="{{ enterFieldValue }}"
          (input)="setSlide($event); countVisitorAction();"
          type="number"
          maxlength="6"
          placeholder="or type amount"
          min="0"
          >
      }
      @if (!inputModeTest) {
        <input class="input is-large" value="{{ enterStringFieldValue }}" (input)="setSlide($event); countVisitorAction();"
          type="text" inputmode="numeric" pattern="[0-9]*" placeholder="or type amount" digitOnly>
      }
      @if (validationMessage) {
        <p class="help is-danger">{{ validationMessage }}</p>
      }
    </div>
  </div>
</div>

<!-- FRU-24242: Continue and No mortgage side by side on desktop, stacked on mobile -->
<div class="balance-actions">
  <button class="button continue is-large has-shadow-small" (click)="submit(sliderValue)">
    Continue
    <i class="fas fa-chevron-right"></i>
  </button>
  <button type="button" class="button is-large has-shadow-small no-mortgage-button" (click)="noMortgage()">
    No mortgage
  </button>
</div>
